<template>
  <dai-tarjeta-contenedor-mapa
    :permitir-colapso="false"
    :es-version-escritorio-en-pantalla-larga="false"
    :llenar-espacio-disponible-con-mapa="true"
  >
    <template #header>
      <h3>
        {{ encabezado }}
      </h3>
    </template>
    <dai-mapa
      class="mapa"
      ref="mapa"
      :extension="[
        -118.365119934082, 14.5320978164673, -86.7104034423828,
        32.7186546325684,
      ]"
      @reset_view="setModoNacional"
    >
      <dai-capa-xyz
        url="https://{a-c}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png"
      />
      <dai-capa-geojson
        id="estados_coropleta"
        ref="estados_coropleta"
        :datos="estados_coropleta"
        :reglas-estilo-capa="{
          clasificacion: 'cuantiles',
          columna: 'cantidad_muestras',
          colores: 'Greys',
          clases: 5,
        }"
        :zoomAlDarClick="true"
        :realce-al-pasar-mouse="true"
        :estilo-realce="{
          stroke: {
            color: 'black',
            width: 2,
          },
          zIndex: 3,
        }"
        @click_feature="clickEnEstado"
        :contenido-tooltip="tooltip_unificar"
      />

      <dai-capa-geojson
        v-for="capa in parametros_estados_circulos"
        :key="capa.id"
        :id="'estados_circulos_' + capa.id"
        :datos="capa.datos"
        :reglas-estilo-capa="capa.reglas_estilo"
        :estilo-capa="capa.estilo"
        :zoomAlDarClick="false"
        @click_feature="clickEnCirculo"
        :props-asigna-estilo="['circle.stroke.color']"
        :fn-asigna-estilo="
          (featureProps) => [
            featureProps.cantidad === 0 ? 'transparent' : 'white',
          ]
        "
      />
    </dai-mapa>

    <template #footer>
      <dai-leyenda-mapa
        class="leyenda-coropleta"
        para="estados_coropleta"
        titulo="Número de muestras secuenciadas"
        v-width-control="{ mobile: '100%', desktop: '100%' }"
      />
      <hr class="dai-map-separator" />
      <div
        v-width-control="{ mobile: '100%', desktop: '50%' }"
        class="container-legend-radios"
      >
        <h4>{{ title_variantes_oms }}</h4>
        <div class="legend-radio-buttons">
          <label
            v-for="variante in variantes_oms_lista"
            :key="variante.value"
            class="radio-item"
          >
            <input
              class="circle-radio-button"
              type="radio"
              name="subvariantes"
              :value="variante.value"
              v-model="variante_oms_seleccionada"
              :style="{ backgroundColor: variante.color }"
              @change="preparar_estados_circulos"
            />
            <span class="etiqueta">{{ variante.title }}</span>
          </label>
        </div>
      </div>

      <dai-leyenda-mapa
        v-width-control="{ mobile: '100%', desktop: '50%' }"
        v-for="capa in parametros_estados_circulos"
        :key="capa.id"
        :para="'estados_circulos_' + capa.id"
        class="leyenda-cirulos-tamanos"
      />
    </template>
  </dai-tarjeta-contenedor-mapa>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import estados_coropleta from "@/assets/datasets/estados_coropleta.json";
import estados_centros from "@/assets/datasets/estados_centros.json";
import consorcio_mapa from "@/assets/datasets/consorcio_mapa.json";
import diccionario_colores from "@/assets/data/diccionario-colores.json";

// const tipo_clases = ["cuantiles", "linear", "cortes-naturales"];
const default_estilo_circulos = {
  clasificacion: "linear",
  /*clasificacionPersonalizada: [
    [0, 0],
    [1, 10],
    [10, 50],
    [50, 200],
    [200, 1000],
    [1000, 4202],
  ],*/
  columna: "cantidad",
  propiedadObjetivo: "proporcion",
  proporciones: [5, 8, 12, 15, 18],
  clases: 5,
  tituloVariable: "Número de muestras relacionadas con las variantes",
};

const default_fill_estilo = {
  circle: {
    fill: { color: diccionario_colores["VTODAS"].color },
    stroke: { color: "white" },
  },
};

export default {
  data() {
    return {
      estados_coropleta: estados_coropleta,
      parametros_estados_circulos: [],
      variante_oms_seleccionada: "VTODAS",
      enunciadoFinalTooltip:
        "muestras relacionadas con las<br>variantes del virus SARS-CoV-2",
      conteo_circulos: {},
    };
  },
  methods: {
    preparar_estados_circulos() {
      if (this.parametros_estados_circulos.length == 0) {
        this.parametros_estados_circulos.push({
          id: 0,
          datos: estados_centros,
          reglas_estilo: default_estilo_circulos,
          estilo: default_fill_estilo,
          enunciado_tooltip: (d) => {
            return `${d["estado"]}<br>
              <strong>${d["cantidad"]}</strong> ${this.enunciadoFinalTooltip}<br>`;
          },
        });
      }
      let tipo = this.$store.getters.varianteSeleccionada;
      //preparar los datos
      let variante_oms_seleccionada1 =
        tipo == "VTODAS" ? "todas" : this.variante_oms_seleccionada;
      tipo = tipo == "VTODAS" ? this.variante_oms_seleccionada : tipo;
      //console.log(tipo,variante_oms_seleccionada1)
      const datos = calculaCantidadesVariantesXEstado(
        tipo,
        variante_oms_seleccionada1
      );
      this.conteo_circulos = datos;
      // console.log(datos)
      this.parametros_estados_circulos[0].datos.features =
        estados_centros.features.map((f, i) => {
          f.properties["cantidad"] = datos[f.properties["cve_edo"]];
          return f;
        });
      if (tipo === "VTODAS" || variante_oms_seleccionada1 === "todas") {
        this.parametros_estados_circulos[0].estilo.circle.fill.color =
          diccionario_colores[tipo].color + "B4";
        //console.log(tipo,variante_oms_seleccionada1)
        this.enunciadoFinalTooltip =
          tipo === "VTODAS"
            ? "muestras relacionadas con las<br>variantes del virus SARS-CoV-2"
            : "muestras relacionadas con las<br>variantes " +
              diccionario_colores[tipo].title2;
      } else {
        this.parametros_estados_circulos[0].estilo.circle.fill.color =
          diccionario_colores[tipo].variantes[variante_oms_seleccionada1] +
          "B4";
        //this.parametros_estados_circulos[0].enunciado_tooltip = this.enunciadoFinalTooltip
      }

      this.parametros_estados_circulos[0].id =
        this.parametros_estados_circulos[0].id + 1;
    },
    tooltip_unificar(d) {
      let conteo = this.conteo_circulos[d["cve_edo"]];
      if (
        this.$store.getters.varianteSeleccionada === "VTODAS" &&
        this.variante_oms_seleccionada === "VTODAS"
      ) {
        return `${d["estado"]}<br><b>${d[
          "cantidad_muestras"
        ].toLocaleString()}</b> muestras secuenciadas<br>`;
      }
      return `${d["estado"]}<br><b>${d[
        "cantidad_muestras"
      ].toLocaleString()}</b> muestras secuenciadas<br>
        <strong>${conteo.toLocaleString()}</strong> ${
        this.enunciadoFinalTooltip
      }<br>`;
    },
    acercamientoEstatal: function () {
      const estado_seleccionado = this.$store.getters.estadoSeleccionado;
      let estados_coropleta = this.$refs.estados_coropleta.olLayer;
      let estado_actual = estados_coropleta
        .getSource()
        .getFeatures()
        .find(
          (feature) => feature.getProperties().cve_edo == estado_seleccionado
        );

      this.$refs.mapa.map
        .getView()
        .fit(estado_actual.getGeometry(), { duration: 500 });
    },
    clickEnEstado: function (feature_layer) {
      this.$store.commit(
        "seleccionarEstado",
        feature_layer[0].getProperties()["cve_edo"]
      );
    },
    clickEnCirculo([feature]) {
      this.$store.commit(
        "seleccionarEstado",
        feature.getProperties()["cve_edo"]
      );
    },
    tooltipConBoton(contenido) {
      return `<div class="text">${contenido}</div>
        <button class="boton-cerrar-tooltip"></button>`;
    },
    setModoNacional() {
      this.$store.commit("seleccionarEstado", "00");
    },
  },
  mounted() {
    if (this.$store.getters.varianteSeleccionada === "VTODAS") {
      this.variante_oms_seleccionada = "VTODAS";
    } else {
      this.variante_oms_seleccionada = "todas";
    }
    setTimeout(() => {
      this.preparar_estados_circulos();
    }, 100);
  },
  computed: {
    ...mapState(["variante_seleccionada", "estado_seleccionado"]),
    variantes_oms_lista() {
      if (this.$store.getters.varianteSeleccionada == "VTODAS") {
        return Object.keys(diccionario_colores)
          .map((item) => ({
            title: diccionario_colores[item].title,
            value: item,
            color: diccionario_colores[item].color,
          }))
          .filter(
            (variante) =>
              !["VRESTANTES", ...this.variantesConConteoOmsCero].includes(
                variante.value
              )
          );
      }

      if (this.$store.getters.varianteSeleccionada == "VSIN") {
        return [
          {
            title: "Otras",
            value: "todas",
            color: diccionario_colores["VSIN"].color,
          },
        ];
      }

      let variantes_oms = Object.keys(
        diccionario_colores[this.$store.getters.varianteSeleccionada].variantes
      ).map((item) => {
        return {
          title: item,
          value: item,
          color:
            diccionario_colores[this.$store.getters.varianteSeleccionada]
              .variantes[item],
        };
      });
      if (variantes_oms.length > 1) {
        variantes_oms.unshift({
          title: "Todas",
          value: "todas",
          color:
            diccionario_colores[this.$store.getters.varianteSeleccionada].color,
        });
      }
      return variantes_oms;
    },
    title_variantes_oms: function () {
      let tipo = this.$store.getters.varianteSeleccionada;
      return "Variantes " + diccionario_colores[tipo].title2;
    },
    encabezado() {
      const varianteSeleccion = this.$store.getters.varianteSeleccionada;
      // const estadoSeleccion = this.$store.getters.estadoSeleccionado;
      let titleVariante = "variantes del virus SARS-CoV-2";
      if (varianteSeleccion !== "VTODAS") {
        titleVariante = diccionario_colores[varianteSeleccion].title2;
        titleVariante = `variantes ${titleVariante}`;
      }

      return `Distribución geográfica de las ${titleVariante} según el número de muestras secuenciadas`;
    },
    variantesConConteoOmsCero() {
      return this.$store.getters.variantesConConteoOmsCero;
    },
  },
  watch: {
    variante_seleccionada: function (newValue) {
      if (newValue === "VTODAS") {
        this.variante_oms_seleccionada = "VTODAS";
      } else {
        this.variante_oms_seleccionada = "todas";
      }
      this.preparar_estados_circulos();

      setTimeout(() => {
        this.$refs.mapa.forceResizeMap();
      }, 50);
      this.enunciadoFinalTooltip =
        newValue === "VTODAS"
          ? "muestras relacionadas con las<br>variantes del virus SARS-CoV-2"
          : "muestras relacionadas con las<br>variantes " +
            diccionario_colores[newValue].title2;
    },
    estado_seleccionado: function (newValue) {
      if (newValue == "00") {
        this.$refs.mapa.external_force_reset_view();
      } else {
        this.acercamientoEstatal();
      }
    },
  },
};

const calculaCantidadesVariantesXEstado = (tipo_variante, variante_oms) => {
  //hacer la suma de todas
  let fn_compara;
  if (tipo_variante === "VTODAS") {
    if (variante_oms === "todas") {
      fn_compara = (accum, current, tipoV, omsV) => {
        return current.cantidad_muestras;
      };
    } else {
      fn_compara = (accum, current, tipoV, omsV) => {
        return current.variante_oms === omsV ? current.cantidad_muestras : 0;
      };
    }
  } else {
    if (variante_oms === "todas") {
      fn_compara = (accum, current, tipoV, omsV) => {
        return current.tipo_variante === tipoV ? current.cantidad_muestras : 0;
      };
    } else {
      fn_compara = (accum, current, tipoV, omsV) => {
        return current.tipo_variante === tipoV && current.variante_oms === omsV
          ? current.cantidad_muestras
          : 0;
      };
    }
  }

  return consorcio_mapa.reduce((accumulate, currentValue) => {
    if (!(currentValue.cve_edo in accumulate)) {
      accumulate[currentValue.cve_edo] = 0;
    }
    accumulate[currentValue.cve_edo] =
      accumulate[currentValue.cve_edo] +
      fn_compara(accumulate, currentValue, tipo_variante, variante_oms);
    return accumulate;
  }, {});
};
/* eslint-enable */
</script>

<style lang="scss" scoped>
.container-legend-radios {
  > h4 {
    text-align: center;
  }
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    border-right: 1px solid black;
  }
}

.legend-radio-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
  //font-size: .9em;
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    flex-wrap: nowrap;
  }
  .radio-item {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 30%;
    height: 100%;
    font-size: 0.9em;
    text-align: center;
    margin-bottom: 10px;
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      flex-grow: 0;
      /* flex-basis: 16%; */
      /* max-width: 16.6%; */
    }
    .circle-radio-button {
      height: 28px;
      width: 28px;
      border-radius: 50%;
      border: 1px solid black;
      appearance: none;
      cursor: pointer;
      position: relative;
      margin-bottom: 8px;

      &:checked {
        background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="5" style="fill:white; stroke:black; stroke-width:.5px"/></svg>');
        //background-size: 25px;
        background-repeat: no-repeat;
        background-position: center;
      }
    }
    .etiqueta {
      width: 100%;
      overflow: hidden;
      word-break: break-word;
    }
  }
}

.dai-map-separator {
  margin-top: 1px;
  //@media (min-width: 850px) {
  //  display: none;
  //}
}
</style>

<style lang="scss">
.leyenda-coropleta {
  .header-legend {
    .title-header-legend {
      flex-direction: column;
    }
  }
  .map-legends[data-layer="estados_coropleta"] {
    /* flex-direction: row-reverse; */
    .map-legend-item {
      justify-content: flex-start;
      .dai-map-shape.map-legends-item-color {
        margin-bottom: 8px;
      }
      .map-legends-item-text {
        line-height: inherit;
        font-weight: inherit;
      }
    }
  }
}

.mapa {
  height: 300px !important;
  .ol-tooltipmov {
    min-width: 150px;
    font-weight: 400;
    b {
      font-weight: 600;
    }
  }
}

.leyenda-cirulos-tamanos {
  //margin-top: -1rem !important;
  .header-legend {
    display: none;
  }
  .legend-content {
    > div {
      display: flex;
      flex-direction: column-reverse;
    }
  }
  .shapes {
    flex-direction: row !important;

    margin-bottom: 1.1em;
    & > div.shape-item {
      .dai-map-shape.shape-this-legend {
        margin-bottom: 8px;
      }
      .shape-text-this-legend {
        font-size: inherit;
        line-height: inherit;
        font-weight: inherit;
      }
      // &:first-of-type {
      //   display: none;
      // }
    }
  }
}

.ol-control.ol-attribution {
  font: normal normal 400 10px/12px "Montserrat", sans-serif;
  * {
    font: normal normal 400 10px/12px "Montserrat", sans-serif;
  }
}

.card-map-container .pie-mapa-libreria {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top-color: #f7f7f7 !important;
}
</style>
